import React, { useEffect, useState } from "react";
import { LifeBuoy, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../../lib/auth";

export default function SupportRequests() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/portal/support-requests").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight text-[#0B132B]">Your support requests</h1>
          <p className="text-[#4B5563] mt-2">Track every conversation you've started with the BTC team.</p>
        </div>
        <Link to="/support" className="btc-btn-primary">New Request <ArrowRight className="w-4 h-4" /></Link>
      </div>
      {items.length === 0 ? (
        <div className="bg-white rounded-2xl border border-dashed border-gray-200 p-10 text-center">
          <LifeBuoy className="w-10 h-10 text-[#23803F] mx-auto mb-3" />
          <h3 className="font-bold text-[#0B132B]">No requests yet.</h3>
          <p className="text-sm text-[#4B5563] mt-2">Reach out anytime — we're here.</p>
          <Link to="/support" className="btc-btn-outline mt-5 inline-flex">Start a request</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.id} className="bg-white rounded-2xl border border-gray-100 p-5">
              <div className="flex items-center justify-between mb-1">
                <div className="text-[10px] font-bold uppercase tracking-wider text-[#23803F]">{r.category || "general"}</div>
                <div className="text-xs text-[#4B5563]">{new Date(r.created_at).toLocaleString()}</div>
              </div>
              <p className="text-sm text-[#0B132B]">{r.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
